import {Icon} from "@iconify/react"
import { Link } from "react-router-dom"


export default function StartTrial ({links = '/early-adopters', text = 'Start 14-day free trial'}) {

    return(
        <Link to={links} className="mt-2 md:mt-0 py-2 px-4 w-fit bg-primary-purple-200 text-white rounded-full hover:bg-primary-800 flex items-center group transition-all ease-in-out duration-1000">
        <span>{text}</span>
        <div className="ml-2 text-white text-xl">
          <Icon
            icon="solar:arrow-right-broken"
            className="w-5 h-5 transition-all ease-in-out duration-1000 group-hover:-rotate-45 group-hover:translate-x-1"
          />
        </div>
      </Link>
    )
}